import Icons, { IconsProps } from '../../Icons';

export type IndeterminateCheckboxProps = IconsProps;

export function IndeterminateCheckbox(props: IndeterminateCheckboxProps) {
  return (
    <Icons {...props}>
      <path d="M7.5 12.5H16.5V11.5H7.5V12.5ZM5.625 20C5.15833 20 4.771 19.846 4.463 19.538C4.15433 19.2293 4 18.8417 4 18.375V5.625C4 5.15833 4.15433 4.771 4.463 4.463C4.771 4.15433 5.15833 4 5.625 4H18.375C18.8417 4 19.2293 4.15433 19.538 4.463C19.846 4.771 20 5.15833 20 5.625V18.375C20 18.8417 19.846 19.2293 19.538 19.538C19.2293 19.846 18.8417 20 18.375 20H5.625ZM5.625 19H18.375C18.5417 19 18.6873 18.9373 18.812 18.812C18.9373 18.6873 19 18.5417 19 18.375V5.625C19 5.45833 18.9373 5.31267 18.812 5.188C18.6873 5.06267 18.5417 5 18.375 5H5.625C5.45833 5 5.31267 5.06267 5.188 5.188C5.06267 5.31267 5 5.45833 5 5.625V18.375C5 18.5417 5.06267 18.6873 5.188 18.812C5.31267 18.9373 5.45833 19 5.625 19Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
